import { lazy, Suspense } from 'react';
import { Route, Routes } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import Seo from "./Components/Seo";
import OrganizationSchema from "./Components/OrganizationSchema";
// Home stays eagerly imported — it's the landing page, so splitting it out
// would just add a loading flash on the most common first visit. Every other
// page is lazy so first-visit JS is only the shell + Home instead of the
// whole site in one main bundle.
import Home from './Components/Home';

const FindAgent = lazy(() => import("./Components/FindAgent"));
const Events = lazy(() => import("./Components/Events"));
const EventDetail = lazy(() => import("./Components/EventDetail"));
const FAQs = lazy(() => import("./Components/FAQs"));
const Locations = lazy(() => import("./Components/Locations"));
const HealthcareProvider = lazy(() => import("./Components/HealthcareProvider"));
const About = lazy(() => import('./Components/About'));
const PaceLeadForm = lazy(() => import('./Components/PaceLeadForm'));
const MedicareIntake = lazy(() => import('./Components/Medicare-Intake-Form/medicareIntake'));
const ProviderLeadForm = lazy(() => import('./Components/ProviderLeadForm'));
const PublicBooking = lazy(() => import('./Components/PublicBooking'));
const PrivacyPolicy = lazy(() => import('./Components/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./Components/TermsConditions'));
const NotFound = lazy(() => import('./Components/404Notfound'));

// Shown only for the brief moment a page chunk is downloading on first visit.
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-10 h-10 border-4 border-gray-200 border-t-[#ED1C27] rounded-full animate-spin" />
    </div>
  );
}

function App() {
  return (
    <>
    <Seo />
    <OrganizationSchema />
    <ScrollToTop />
    <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route
        path="/"
        element={
          <Home
          />
        }
      />
      <Route
        path="/FindAgent"
        element={
          <FindAgent />
        }
      />
      <Route
        path="/events"
        element={
          <Events />
        }
      />
      <Route
        path="/events/:id"
        element={
          <EventDetail />
        }
      />
      <Route
        path="/locations"
        element={
          <Locations />
        }
      />
      <Route
        path="/FAQs"
        element={
          <FAQs />
        }
      />
      <Route
        path="/about"
        element={
          <About />
        }
      />
      <Route
        path="/health-care-provider"
        element={
          <HealthcareProvider />
        }
      />
      <Route
        path="/health-care-provider/form"
        element={
          <ProviderLeadForm />
        }
      />
      <Route
        path="/health-care-provider/form/referral/:refID"
        element={
          <ProviderLeadForm />
        }
      />
      <Route
        path="/pace-lead-form"
        element={
          <PaceLeadForm
          />
        }
      />
      <Route
        path="/pace-lead-form/referral/:refID"
        element={
          <PaceLeadForm
          />
        }
      />
      <Route
        path="/medicare-intake-form"
        element={
          <MedicareIntake />
        }
      />
      <Route
        path="/medicare-intake-form/referral/:refID"
        element={
          <MedicareIntake />
        }
      />
      <Route
        path="/book/:token"
        element={
          <PublicBooking />
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <PrivacyPolicy />
        }
      />
      <Route
        path="/terms-conditions"
        element={
          <TermsConditions />
        }
      />
      <Route
        path="*"
        element={
          <NotFound />
        }
      />
    </Routes>
    </Suspense>
    </>
  );
}

export default App;
